module.exports = __webpack_public_path__ + "static/media/romstandard1.5f3100c4.jpeg";